module.exports = __webpack_public_path__ + "static/img/pCT3.5b4e1794.png";